import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  searchbar: {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    width: 'auto',
    maxWidth: '220px',
    padding: '0px',
    margin: '0px',
    transform: 'translateY(2px)',
  },
  searchIcon: {
    marginLeft: '1px',
    position: 'relative',
    top: '1px',
    left: '-4px',
    width: '20px',
    color: '#81818D',
  },
  searchIconContrast: {
    color: 'white',
  },
  searchCloseIcon: {
    position: 'absolute',
    right: '1px',
    width: '12px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: '10px',
  },
}));
